import { Route } from '../Routing/types';
import { LabTestPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/lab-tests/*',
    element: <LabTestPage descendantRoutes={descendantRoutes} />,
    private: true,
    title: dummy_t('route-title/lab-tests'),
    mobileAppTabIdentifier: 'diary',
    descendantRoutes: descendantRoutes,
  },
];

export default routes;
